var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.item.type === 'ticket')?_c('div',[_vm._v("Aufgabe")]):_c('div',[_vm._v("Sonstiges")])])
}
var staticRenderFns = []

export { render, staticRenderFns }